function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 3.75c0-.829-1.68-1.5-3.75-1.5-2.07 0-3.748.672-3.75 1.5 0 .829 1.678 1.5 3.75 1.5s3.75-.671 3.75-1.5M10.5 3.75v5.82M3 6.75c0 .829 1.68 1.5 3.75 1.5 2.072 0 3.75-.671 3.75-1.5M14.761 9.988a3.376 3.376 0 11-4.774 4.773 3.376 3.376 0 014.774-4.773",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.379 10.819c-.677.266-1.604.431-2.629.431-2.07 0-3.75-.671-3.75-1.5",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.334 13.833c-.673.257-1.58.417-2.584.417-2.07 0-3.75-.671-3.75-1.5v-9",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));